import React from 'react';
import {
  Paper,
  Typography,
  Box,
  IconButton,
  Button,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { SavedList } from '../../types';

interface SavedListCardProps {
  list: SavedList;
  onLoadList: (list: SavedList) => void;
  onDeleteList: (listId: number) => void;
  onDeleteClick: (list: SavedList) => void;
}

export const SavedListCard: React.FC<SavedListCardProps> = ({
  list,
  onLoadList,
  onDeleteClick,
}) => {
  return (
    <Paper elevation={2} sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="h6">{list.name}</Typography>
        <IconButton
          color="error"
          onClick={() => onDeleteClick(list)}
          size="small"
          sx={{ ml: 1 }}
        >
          <DeleteIcon />
        </IconButton>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography color="textSecondary">
          {list.recipients.length} recipients
        </Typography>
        <Button
          variant="contained"
          onClick={() => onLoadList(list)}
          size="small"
        >
          Load
        </Button>
      </Box>
    </Paper>
  );
};

export default SavedListCard;
